<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <Main/>
    </v-container>
  </div>
</template>
<script>
import Main from "../../components/Definiciones/GruposDeFeriado/Main.vue"
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
    
    export default {
    components: { LandingToolbar, Main },
    };
</script>
    